import { render, staticRenderFns } from "./PlotPopup.vue?vue&type=template&id=0faa4912&scoped=true&"
import script from "./PlotPopup.vue?vue&type=script&lang=js&"
export * from "./PlotPopup.vue?vue&type=script&lang=js&"
import style0 from "./PlotPopup.vue?vue&type=style&index=0&id=0faa4912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa4912",
  null
  
)

export default component.exports